import { render, staticRenderFns } from "./NoAcces.vue?vue&type=template&id=363fbe0c&scoped=true"
var script = {}
import style0 from "./NoAcces.vue?vue&type=style&index=0&id=363fbe0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363fbe0c",
  null
  
)

export default component.exports